import { createFileRoute } from '@tanstack/react-router';
import { rulesQuery } from '@/features/rules/api';
import { RulePage } from '@/features/rules/pages/RulePage';
import { ruleSearchSchema } from '@/features/rules/search';
import { sourcesQuery } from '@/features/sources/api';

export const Route = createFileRoute('/_authed/ops/rules/$ruleId')({
  staticData: { help: 'trust-rules' },
  validateSearch: ruleSearchSchema,
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(rulesQuery());
    void queryClient.prefetchQuery(sourcesQuery());
  },
  component: RulePage,
});
